import { render, staticRenderFns } from "./roleInvitation.vue?vue&type=template&id=9aa975da&scoped=true&"
import script from "./roleInvitation.vue?vue&type=script&lang=js&"
export * from "./roleInvitation.vue?vue&type=script&lang=js&"
import style0 from "./roleInvitation.vue?vue&type=style&index=0&id=9aa975da&prod&lang=less&scoped=true&"
import style1 from "./roleInvitation.vue?vue&type=style&index=1&id=9aa975da&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa975da",
  null
  
)

export default component.exports